import React from "react";

/**
 * Official DPIIT (Department for Promotion of Industry and Internal Trade)
 * Ministry of Commerce & Industry, Government of India
 */

export function DpiitLogo({ className = "h-11 sm:h-12 w-auto" }) {
  return (
    <div className="inline-flex items-center select-none">
      <img
        src="/dpiit-logo.png"
        alt="DPIIT - Department for Promotion of Industry and Internal Trade"
        className={`${className} object-contain`}
        loading="lazy"
      />
    </div>
  );
}

export function StateEmblemOfIndia({ className = "h-10 w-auto" }) {
  return (
    <img
      src="/dpiit-only-logo.png"
      alt="DPIIT Government of India"
      className={`${className} object-contain`}
      loading="lazy"
    />
  );
}

export default DpiitLogo;
